module.exports = __webpack_public_path__ + "static/media/megabus-logo-background.fffc952a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/megabus-logo-background.svg
// module id = 291
// module chunks = 0